<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="Add Overtime Entries"
      maxWidth="900px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-row class="mt-2">
          <v-col cols="12">
            <SimplePageHeader title="Assignment"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="Consultant"
              v-bind:value="consultantName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="Client"
              v-bind:value="clientName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <FormattedNumberField
              label="Hourly Pay Rate"
              :value="hourlyPayRate"
              :readonly="true"
              prepend-inner-icon="attach_money"
            ></FormattedNumberField>
          </v-col>
          <v-col cols="6" md="3">
            <FormattedNumberField
              label="Hourly Bill Rate"
              :value="hourlyBillRate"
              :readonly="true"
              prepend-inner-icon="attach_money"
            ></FormattedNumberField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-form ref="addEntriesForm">
              <OvertimeEntriesCollector
                :overtimeEntriesTempArray="overtimeEntriesTempArray"
                :hourlyPayRate="hourlyPayRate"
                @dateChangeHandler="dateChangeHandler"
                @otPayRateChangeHandler="otPayRateChangeHandler"
                @otBillRateChangeHandler="otBillRateChangeHandler"
                @hoursChangeHandler="hoursChangeHandler"
                @addTempOvertimeEntry="addTempOvertimeEntry"
                @removeTempOvertimeEntry="removeTempOvertimeEntry"
              ></OvertimeEntriesCollector>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="addOvertimeEntries"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import OvertimeEntriesCollector from './OvertimeEntriesCollector'
import { DynamicModal } from '@/components/dialogs'
import SimplePageHeader from '@/components/pageComponents/SimplePageHeader'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    OvertimeEntriesCollector,
    DynamicModal,
    SimplePageHeader,
    FormattedNumberField
  },
  props: [
    'assignmentId',
    'consultantName',
    'clientName',
    'hourlyPayRate',
    'hourlyBillRate'
  ],
  data () {
    return {
      showModalProp: false,
      overtimeEntriesTempArray: [{
        assignmentId: null,
        date: null,
        otPayRate: null,
        otBillRate: null,
        hours: null
      }]
    }
  },
  methods: {
    ...mapActions('overtimeEntries', ['saveOvertimeEntries']),
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.$emit('closeModal')
    },
    async addOvertimeEntries () {
      if (this.$refs.addEntriesForm.validate()) {
        this.overtimeEntriesTempArray =
          this.overtimeEntriesTempArray.map(
            entry =>
              ({ ...entry, assignmentId: this.assignmentId }))
        this.overtimeEntriesTempArray.forEach(entry => {
          if (!entry.otPayRate) {
            entry.otPayRate = this.hourlyPayRate
          }
          if (!entry.otBillRate) {
            entry.otBillRate = this.hourlyBillRate
          }
        })
        await this.saveOvertimeEntries(this.overtimeEntriesTempArray)
        this.clearOvertimeEntriesTempArray()
        this.$refs.addEntriesForm.resetValidation()
        this.closeModal()
      }
    },
    addTempOvertimeEntry () {
      this.overtimeEntriesTempArray.push({
        assignmentId: null,
        date: null,
        otPayRate: null,
        otBillRate: null,
        hours: null
      })
    },
    removeTempOvertimeEntry (id) {
      this.overtimeEntriesTempArray.splice(id, 1)
    },
    dateChangeHandler (id, newDateValue) {
      this.overtimeEntriesTempArray[id]['date'] = newDateValue
    },
    otPayRateChangeHandler (id, newOTPayRate) {
      this.overtimeEntriesTempArray[id]['otPayRate'] = newOTPayRate
    },
    otBillRateChangeHandler (id, newOTBillRate) {
      this.overtimeEntriesTempArray[id]['otBillRate'] = newOTBillRate
    },
    hoursChangeHandler (id, newHoursValue) {
      this.overtimeEntriesTempArray[id]['hours'] = newHoursValue
    },
    clearOvertimeEntriesTempArray () {
      this.overtimeEntriesTempArray = [{
        assignmentId: null,
        date: null,
        otPayRate: null,
        otBillRate: null,
        hours: null
      }]
    }
  }
}
</script>
